import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import data from '../data';
import { nameToId, scaledImagePath } from '../utils/imageUtils';

interface MyCarouselProps {
  selectedId: string;
  onSelectionChange?: (workName: string) => void;
}

class DemoCarousel extends React.Component<MyCarouselProps> {
  handleChange = (index: number) => {
    if (this.props.onSelectionChange) {
      this.props.onSelectionChange(data.works[index].name);
    }
  };

  render() {
    var items: React.JSX.Element[] = [];
    var selected = 0;
    
    for (var i in data.works) {
      // Why javascript, why.
      let num = parseInt(i, 10);
      if (nameToId(data.works[num].name) === this.props.selectedId) {
        selected = num;
      }
      const work = data.works[num];
      items.push((
        <div className="full" key={work.name}>
          {work.youtubeId ? (
            <div className="video-embed">
              <iframe
                title={work.name}
                src={`https://www.youtube-nocookie.com/embed/${work.youtubeId}?autoplay=1&mute=1&loop=1&playlist=${work.youtubeId}&rel=0&modestbranding=1`}
                allow="autoplay; encrypted-media; picture-in-picture"
                allowFullScreen
              />
            </div>
          ) : (
            <img alt={work.name} src={scaledImagePath(work.image)} />
          )}
          <p className="description">{work.description}</p>
        </div>
      ));
    }

    const selectedWork = data.works[selected];
    const wrapperClass = selectedWork && selectedWork.youtubeId ? "pruts pruts-wide" : "pruts";

    return (
      <div className={wrapperClass}>
        <Carousel 
          showArrows={false} 
          swipeScrollTolerance={60} 
          selectedItem={selected} 
          useKeyboardArrows={true} 
          showStatus={false} 
          showThumbs={false} 
          showIndicators={false}
          onChange={this.handleChange}
        >
          {items}
        </Carousel>
      </div>
    );
  }
}

export default DemoCarousel;